'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.callApiFactory = exports.callApi = exports.resolveUrl = exports.isServerError = exports.defaultFetchHeaders = exports.DEFAULT_URL = undefined;

var _camelCase2 = require('lodash/camelCase');

var _camelCase3 = _interopRequireDefault(_camelCase2);

var _merge2 = require('lodash/fp/merge');

var _merge3 = _interopRequireDefault(_merge2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _whatwgFetch = require('whatwg-fetch');

var _url = require('url');

var _url2 = _interopRequireDefault(_url);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DEFAULT_URL = exports.DEFAULT_URL = 'http://localhost';

var normalizeCasing = function normalizeCasing(object) {
  if (!object || (typeof object === 'undefined' ? 'undefined' : _typeof(object)) !== 'object') {
    return object;
  }
  if (Array.isArray(object)) {
    return object.map(normalizeCasing);
  }

  return Object.keys(object).reduce(function (acc, key) {
    return _extends({}, acc, _defineProperty({}, (0, _camelCase3.default)(key), normalizeCasing(object[key])));
  }, {});
};

var defaultFetchHeaders = exports.defaultFetchHeaders = {
  compress: false,
  credentials: 'same-origin',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
};

var cleanBody = function cleanBody(entity) {
  return Object.keys(entity).reduce(function (acc, key) {
    var value = entity[key];
    if (value == null || typeof value === 'string' && !value.trim().length) {
      return acc;
    }
    if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
      if (!Object.keys(value).length) {
        return acc;
      }
      return _extends({}, acc, _defineProperty({}, key, cleanBody(value)));
    }
    return _extends({}, acc, _defineProperty({}, key, value));
  }, {});
};

var isServerError = exports.isServerError = function isServerError(status) {
  if (status >= 500 && status < 600) {
    return true;
  }
  return false;
};

var isAbsolutePath = function isAbsolutePath(url) {
  return (/https?:\/\//.test(url)
  );
};

var resolveUrl = exports.resolveUrl = function resolveUrl(baseUrl) {
  var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (!url) {
    return baseUrl;
  }
  if (baseUrl && isAbsolutePath(baseUrl) && !isAbsolutePath(url)) {
    return _url2.default.resolve(baseUrl, url);
  }
  return url;
};

var callApi = function callApi() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : { normalize: true },
      _ref$normalize = _ref.normalize,
      normalize = _ref$normalize === undefined ? true : _ref$normalize;

  var apiUrl = resolveUrl(DEFAULT_URL, url);

  var params = options.params,
      restOptions = _objectWithoutProperties(options, ['params']);

  var urlObj = _url2.default.parse(apiUrl);
  urlObj.query = urlObj.query || params || '';
  var urlString = _url2.default.format(urlObj);
  var fetchOptions = (0, _merge3.default)(defaultFetchHeaders)(restOptions);
  return fetch(urlString, cleanBody(fetchOptions)).then(function (resp) {
    if (resp.status !== 204) {
      return resp.text().then(function (text) {
        try {
          return { resp: resp, json: JSON.parse(text) };
        } catch (e) {
          return { resp: resp, json: { message: text } };
        }
      }).then(function (obj) {
        var results = _extends({}, obj, {
          json: normalize ? normalizeCasing(obj.json) : obj.json
        });
        return isServerError(results.resp.status) ? Promise.reject(results) : results;
      });
    }
    return { json: null, resp: resp };
  });
};

exports.callApi = callApi;
var callApiFactory = exports.callApiFactory = function callApiFactory() {
  var baseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var baseOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function () {
    for (var _len = arguments.length, rest = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      rest[_key - 2] = arguments[_key];
    }

    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return callApi.apply(undefined, [resolveUrl(baseUrl, url), (0, _merge3.default)(baseOptions)(options)].concat(rest));
  };
};

exports.default = callApiFactory;


//////////////////
// WEBPACK FOOTER
// /Users/runner/work/1/s/engage.framework/lib/utils/call-api/index.js
// module id = 973
// module chunks = 2